import React, { useRef } from "react";
import { twMerge } from "@stereoagency/tailwind-config";
import { ProfileSummary } from "../../molecules/ProfileSummary";
import { EntryAnimation } from "../../atoms";
export default function EventFooter(param) {
    var profiles = param.profiles, _param_showDivider = param.showDivider, showDivider = _param_showDivider === void 0 ? true : _param_showDivider;
    var footerRef = useRef(null);
    return /*#__PURE__*/ React.createElement("footer", {
        ref: footerRef,
        className: twMerge("pt-0", showDivider && "mt-6 md:mt-9 md:border-t md:border-t-fg-base/20 md:pt-9")
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap justify-start items-start -m-5"
    }, profiles.map(function(profile, profileIndex) {
        return /*#__PURE__*/ React.createElement(EntryAnimation, {
            key: profile.name,
            view: footerRef,
            delay: profileIndex * 0.1,
            className: "m-5"
        }, /*#__PURE__*/ React.createElement(ProfileSummary, profile));
    }))));
}

//# sourceMappingURL=EventFooter.js.map